module.exports = "<footer class=\"main-footer\" style=\"position: fixed;\r\nbottom: 0;\r\nwidth: 100%;\r\nfont-size: 11px;\">\r\n  <div class=\"footer-set \">\r\n    <div style=\"\r\n        float: right;\r\n    \">\r\n      <a href=\"http://www.digicopsolutions.com/\" target=\"_blank\">\r\n        <img src=\"assets/Images/complogo.png\">\r\n      </a>\r\n      Copyright ©. All Rights Reserved. Version ( {{version}} )\r\n    </div>\r\n  </div>\r\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shell/shell-templates/footer.component.html
// module id = 1067
// module chunks = 22